import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { SectionCreatePage } from '@/features/content';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/sections/new')({
  staticData: { crumb: 'content:sectionsList.new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.write');
  },
  component: SectionCreatePage,
});
